export default __webpack_public_path__ + "static/media/thinkers_logo.d12ebb6d.svg";